import { chakra, Text, VStack, Button, Stack } from '@chakra-ui/react'

export const SidebarTitle = chakra(Text, {
  baseStyle: {
    color: 'gray.800',
    lineHeight: 7,
    fontSize: '20px',
    fontWeight: 700,
    display: { base: 'block', lg: 'none' }
  }
})

export const SidebarContent = chakra(VStack, {
  baseStyle: {
    justifyContent: 'flex-start',
    height: '100%',
    width: '100%'
  }
})

export const SidebarWrapper = chakra(VStack, {
  baseStyle: {
    height: '100%',
    width: { base: '100%', lg: '256px' },
    position: 'sticky',
    top: '104px',
    alignItems: 'start',
    padding: { base: '24px 16px 40px', md: '40px 32px', lg: '0px' }
  }
})

export const LogoutButton = chakra(Button, {
  baseStyle: {
    border: '1px solid #C53030',
    background: 'none',
    display: { base: 'flex', md: 'block', lg: 'none' },
    width: { base: '100%', md: 'auto' },
    justifyContent: { sm: 'center' }
  }
})

export const ContentWrapper = chakra(VStack, {
  baseStyle: {
    paddingX: { base: 4, md: 8, lg: 0 },
    paddingY: { base: 6, md: 10, lg: 0 },
    ' > form': {
      width: { base: '100%' }
    }
  }
})

export const Title = chakra(Text, {
  baseStyle: {
    color: 'gray.700',
    fontWeight: 600,
    fontSize: 'md',
    lineHeight: 6
  }
})

export const FormLabel = chakra(Text, {
  baseStyle: {
    color: 'gray.700',
    fontWeight: 500,
    fontSize: 'md',
    lineHeight: 6
  }
})

export const FormField = chakra(VStack, {
  baseStyle: {
    alignItems: 'flex-start',
    flex: 1,
    width: '100%'
  }
})

export const SectionWrapper = chakra(VStack, {
  baseStyle: {
    width: 'full',
    alignItems: 'flex-start',
    padding: { base: 4, lg: 8 },
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
    borderRadius: '8px'
  }
})

export const SubmitButton = chakra(Button, {
  baseStyle: {
    background: 'teal.500',
    color: 'white',
    lineHeight: 5,
    paddingY: '6px',
    paddingX: 3,
    borderRadius: '6px',
    _active: {
      background: 'teal.500'
    },
    _hover: {
      background: 'teal.500'
    }
  }
})

export const UploadButton = chakra(Button, {
  baseStyle: {
    background: 'white',
    flexDirection: 'row',
    fontSize: { base: 'lg', lg: 'md' },
    lineHeight: { base: 7, lg: 6 },
    width: 'full',
    height: { base: 12, lg: 10 },
    color: 'gray.700',
    border: '1px solid #E2E8F0',
    bordeRadius: '6px'
  }
})

export const RowWrapper = chakra(Stack, {
  baseStyle: {
    width: 'full',
    gap: { md: 6, lg: 8 },
    flexDirection: { base: 'column', md: 'row' },
    alignItems: { md: 'flex-start' }
  }
})
